<div class="cart-drawer-container">
  <div class="cart-header">
    <h2>Tu Carrito</h2>
    <button mat-icon-button (click)="close()">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div class="cart-content">
    @if (cart.isUpdating()) {
      <div class="loading-overlay">
        <mat-spinner diameter="40"></mat-spinner>
      </div>
    }

    @if (cart.items().length === 0) {
      <div class="empty-cart">
        <mat-icon>shopping_cart</mat-icon>
        <p>Tu carrito está vacío</p>
        <button mat-flat-button color="primary" (click)="close()">Empezar a comprar</button>
      </div>
    } @else {
      <div class="cart-items">
        @for (item of cart.items(); track item.key) {
          <div class="cart-item">
            <div class="item-info">
              <h4>{{ item.product.node.name }}</h4>

              <div class="quantity-stepper">
                @if (item.quantity === 1) {
                  <button mat-icon-button color="warn" class="qty-btn" (click)="cart.removeItem(item.key)">
                    <mat-icon>delete_outline</mat-icon>
                  </button>
                } @else {
                  <button mat-icon-button class="qty-btn" (click)="cart.updateQuantity(item.key, item.quantity - 1)">
                    <mat-icon>remove</mat-icon>
                  </button>
                }

                <span class="quantity">{{ item.quantity }}</span>
                <button mat-icon-button class="qty-btn" (click)="cart.updateQuantity(item.key, item.quantity + 1)">
                  <mat-icon>add</mat-icon>
                </button>
              </div>

            </div>
            <div class="item-price">
              <span [innerHTML]="item.subtotal"></span>
            </div>
          </div>
        }
      </div>
    }
  </div>

  @if (cart.items().length > 0) {
    <div class="cart-footer">
      <div class="cart-total">
        <span>Total:</span>
        <strong [innerHTML]="cart.cartTotal()"></strong>
      </div>
      <button mat-flat-button color="primary" class="checkout-btn" (click)="checkout()">
        Proceder al checkout
      </button>
    </div>
  }
</div>
